export const MAYA_NOTE = "School called today. Maya had a hard transition after lunch and became very upset when they moved from art to math. Her teacher said giving her a five-minute warning helped her settle. She used her communication card to ask for a break and returned to class after about 10 minutes.";

export const ORGANIZED_DETAILS = [
  { label: "Timeline", text: "Maya had difficulty transitioning from art to math after lunch." },
  { label: "What helped", text: "A five-minute warning helped Maya transition." },
  { label: "Communication", text: "Maya used her communication card to request a break." },
];

export const TIMELINE_ENTRIES = [
  {
    id: "aug-18",
    date: "Aug 18",
    title: "School transition was difficult after lunch",
    summary: "A five-minute warning helped Maya settle and return to class.",
    source: MAYA_NOTE,
    details: ["Transition difficulty", "Communication", "Strategy that helped"],
  },
  {
    id: "aug-14",
    date: "Aug 14",
    title: "Poor sleep and more sensitivity to noise",
    summary: "Maya slept poorly and seemed more sensitive to noise at school.",
    source: "Maya was awake several times last night. Her teacher said the classroom felt especially loud to her today.",
    details: ["Sleep", "Sensory sensitivity", "School"],
  },
  {
    id: "aug-11",
    date: "Aug 11",
    title: "Used her communication card independently",
    summary: "Her speech therapist reported two independent requests for a break.",
    source: "Great speech session today — Maya used her communication card twice to ask for a break without a prompt.",
    details: ["Communication", "Therapy update", "Progress"],
  },
  {
    id: "aug-5",
    date: "Aug 5",
    title: "A visual schedule made mornings smoother",
    summary: "Transitions went better when Maya saw the schedule before getting dressed.",
    source: "Morning went much more smoothly when I showed Maya the picture schedule before we started getting dressed.",
    details: ["Routine", "Transition", "Strategy that helped"],
  },
];

export const PROFILE_SECTIONS = [
  { title: "Communication", icon: "chat", items: ["Uses communication cards when overwhelmed", "Responds better when given time to process instructions"] },
  { title: "What helps", icon: "heart", items: ["Five-minute warnings before transitions", "Visual schedules", "A quiet break when overwhelmed"] },
  { title: "Watch for", icon: "eye", items: ["Difficult transitions after lunch", "Increased sensitivity after poor sleep"] },
  { title: "Goals", icon: "goal", items: ["Increase functional communication", "Improve independent transitions"] },
];

export const MEETING_INSIGHTS = [
  {
    title: "Transition support",
    text: "Maya has had several difficult transitions after lunch. Advance warnings and visual schedules have helped.",
    evidenceLabel: "View 3 supporting moments",
    entryIds: ["aug-18", "aug-5", "aug-14"],
  },
  {
    title: "Communication progress",
    text: "Maya has increasingly used her communication card to request breaks.",
    evidenceLabel: "View 2 supporting moments",
    entryIds: ["aug-18", "aug-11"],
  },
  {
    title: "Patterns to mention",
    text: "Poor sleep may be associated with increased sensitivity the following day.",
    evidenceLabel: "View supporting moment",
    entryIds: ["aug-14"],
  },
];

export const MEETING_QUESTIONS = [
  "Can five-minute transition warnings be used consistently?",
  "Can Maya’s communication card remain accessible throughout the day?",
  "Should visual schedules be used during afternoon transitions?",
];
